import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// BURAYI EKLEYİN
import { BrowserRouter } from 'react-router-dom'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* APP'İ BURADA BROWSERROUTER İLE SARIN */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);